import { getRoute } from '@utils/route';
import { GetAllCarQuoteParams } from '@apis/CarQuoteApi';

export type CarQuoteResultPageParams = GetAllCarQuoteParams;

export const CAR_QUOTE_RESULT_PAGE_URL = '/car-insurance-quote-results';

export const routeCarQuoteResultPage = (searchParams: CarQuoteResultPageParams) => getRoute(CAR_QUOTE_RESULT_PAGE_URL, { searchParams });
